import { useState, useEffect } from "react";

function useMediaQuery(query) {
    const [matches, setMatches] = useState(window.matchMedia(query).matches);

    useEffect(() => {
        const mediaQueryList = window.matchMedia(query);

        const updateMatches = (event) => setMatches(event.matches);

        // Initial check and listener setup
        mediaQueryList.addEventListener("change", updateMatches);

        // Cleanup listener on unmount
        return () => {
            mediaQueryList.removeEventListener("change", updateMatches);
        };
    }, [query]);

    return matches;
}

export default useMediaQuery;